<!-- <p (click)="handle()">test works!</p> -->

<div class="container">
	<div>
		<app-shared-dropdown (dropdownValues)="handleDropDown($event)" [dropdownToShow]="sharedDropdown.facebookAndGoogleOptions"></app-shared-dropdown>
	</div>
</div>
